export default {"container":"_9jbS9","title":"VKblt","tabs":"UtoGA","content":"vpeff"};